import { persistReducer as persistReducer$1 } from "redux-persist";
import { default as default2 } from "redux-persist/lib/storage";
import { default as default3 } from "redux-persist/lib/storage/session";
const persistReducer = (config, reducer) => {
  if (typeof window !== "undefined" && window.document) {
    return persistReducer$1(config, reducer);
  }
  return reducer;
};
export {
  default2 as localStorage,
  persistReducer,
  default3 as sessionStorage
};
//# sourceMappingURL=index.js.map
